import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Headphones = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
        <path
          d="M3.6001 15.6H6.0001C6.66284 15.6 7.2001 16.1372 7.2001 16.8V19.2C7.2001 19.8627 6.66284 20.4 6.0001 20.4H3.6001V12C3.6001 7.36078 7.36091 3.59998 12.0001 3.59998C16.6393 3.59998 20.4001 7.36078 20.4001 12V20.4H18.0001C17.3374 20.4 16.8001 19.8627 16.8001 19.2V16.8C16.8001 16.1372 17.3374 15.6 18.0001 15.6H20.4001"
          stroke={color}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)
